<template>
  <span class="clickable" @click="buttonClicked()">
    <img v-if="completed" alt="completed" src="../../../../../assets/images/completed.svg">
    <img v-else alt="incomplete" src="../../../../../assets/images/incomplete.svg">
  </span>
</template>

<script>
export default {
  props: {
    completed: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    buttonClicked () {
      this.$emit('toggled')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
img {
  max-width: 8rem;
  width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/mark-as-completed.vue